var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockedCheckpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "#F3F8FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_459_23914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0002 32V30C54.0002 26.287 52.5252 22.726 49.8997 20.1005C47.2742 17.475 43.7133 16 40.0002 16C36.2872 16 32.7263 17.475 30.1007 20.1005C27.4752 22.726 26.0002 26.287 26.0002 30V32H20.0002V58C20.0002 59.5913 20.6324 61.1174 21.7576 62.2426C22.8828 63.3679 24.4089 64 26.0002 64H54.0002C55.5915 64 57.1177 63.3679 58.2429 62.2426C59.3681 61.1174 60.0002 59.5913 60.0002 58V32H54.0002ZM30.0002 30C30.0002 27.3478 31.0538 24.8043 32.9292 22.9289C34.8045 21.0536 37.3481 20 40.0002 20C42.6524 20 45.1959 21.0536 47.0713 22.9289C48.9467 24.8043 50.0002 27.3478 50.0002 30V32H30.0002V30ZM56.0002 58C56.0002 58.5304 55.7895 59.0391 55.4145 59.4142C55.0394 59.7893 54.5307 60 54.0002 60H26.0002C25.4698 60 24.9611 59.7893 24.586 59.4142C24.211 59.0391 24.0002 58.5304 24.0002 58V36H56.0002V58Z",
    fill: "#5A646B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0003 44H38.0002V52H42.0003V44Z",
    fill: "#5A646B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_459_23914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedCheckpoint);
export default __webpack_public_path__ + "static/media/lockedCheckpoint.e4a3210a5359f0ebf87b3a8c25023e99.svg";
export { ForwardRef as ReactComponent };